import { useBalanceWithPoints } from "@apac/components/checkout";
import { useModuleBEM } from "@b2bportal/core-themes";
import { ProductType } from "@b2bportal/core-types";
import { CheckoutPage } from "@components/checkout";
import {
  CardPaymentSelectors,
  ParentState,
  useCheckoutSend,
  useCheckoutStateSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  CheckoutStepHeader,
  TravelCreditsSelection,
  ReviewDetailsButton,
} from "@hsbc/portal";
import { RewardsSelection } from "@hsbc/rewards";
import { ConnectedPaymentInformation } from "../../connectedComponents/PaymentInformation";
import { CheckoutEvent, type TEvent } from "../../events";
import { useFlightCheckoutHeaderSteps } from "../../hooks/useFlightCheckoutHeaderSteps";
import styles from "./styles.module.scss";

export const PaymentPage = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PaymentPage");

  const send = useCheckoutSend<TEvent>();
  const handleContinue = () => {
    send({ type: CheckoutEvent.NEXT, productType: ProductType.FLIGHTS });
  };

  const selectedPaymentMethod = !!useCheckoutStateSelector(
    CardPaymentSelectors.getSelectedPaymentMethodId
  );
  const { remainingBalance } = useBalanceWithPoints();

  const isStepValid = selectedPaymentMethod || remainingBalance.value === 0;

  const checkoutHeaderSteps = useFlightCheckoutHeaderSteps();

  return (
    <CheckoutPage
      className={block}
      title={t("checkoutSection.title")}
      onContinue={handleContinue}
      continueButtonDisabled={!isStepValid}
      bottomSection={
        <ReviewDetailsButton
          onContinue={handleContinue}
          continueButtonDisabled={!isStepValid}
        />
      }
    >
      <div className={cn("header-container")}>
        <CheckoutStepHeader
          steps={checkoutHeaderSteps}
          currentStep={ParentState.payment}
        />
        <span className={cn("title")}>{t("payment.title")}</span>
        <span className={cn("subtitle")}>{t("payment.subTitle")}</span>
      </div>

      <div className={cn("container")}>
        <TravelCreditsSelection />

        <RewardsSelection />

        <ConnectedPaymentInformation />
      </div>
    </CheckoutPage>
  );
};
